export function getUniversalTime() {
  return +new Date();
}

export default {
  getUniversalTime,
};
